<template>
    <div class="school-subject-permissions">
        <div style="margin-top: 10px;">
            <el-form :model="formInline" :inline="true" class="form-style" size="mini">
                <el-form-item label="数据类型">
                    <el-select v-model="formInline.data_type" placeholder="请选择" clearable>
                        <el-option label="学校" value="1"></el-option>
                        <el-option label="科目" value="2"></el-option>
                        <el-option label="课程体系" value="3"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="search">查询</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="table-style">
            <el-table size="mini" :data="tableData" :header-cell-style="{ background: '#f5f7fa' }">
                <el-table-column align="center" width="50" label="序号">
                    <template slot-scope="scope">
                        {{ scope.$index + 1 }}
                    </template>
                </el-table-column>

                <el-table-column prop="schoolName" label="校区名称"></el-table-column>
                <el-table-column prop="curriculumName" label="课程体系"></el-table-column>
                <el-table-column prop="subject" label="科目"></el-table-column>

                <el-table-column prop="" label="操作类型">
                    <template slot-scope="scope">
                        <span v-if="scope.row.operate_type === 1">添加</span>
                        <span v-if="scope.row.operate_type === 2">更新</span>
                        <span v-if="scope.row.operate_type === 3">删除</span>
                    </template>
                </el-table-column>
                <el-table-column prop="" label="数据类型">
                    <template slot-scope="scope">
                        <span v-if="scope.row.data_type === 1">学校</span>
                        <span v-if="scope.row.data_type === 2">科目</span>
                        <span v-if="scope.row.data_type === 3">课程体系</span>

                    </template>
                </el-table-column>

                <el-table-column align="center" prop="created_time" label="操作时间" show-overflow-tooltip></el-table-column>
                <el-table-column align="center" prop="origin_date" label="更新前日期" show-overflow-tooltip></el-table-column>
                <el-table-column align="center" prop="now_date" label="当前日期" show-overflow-tooltip></el-table-column>
                <el-table-column align="center" prop="authUserName" label="操作人"></el-table-column>


            </el-table>
        </div>
        <div class="pagination-style">

            <el-pagination @current-change="handleCurrentChange" :current-page.sync="page_no" :page-size="page_size"
                layout="total, prev, pager, next" :total="total"></el-pagination>
        </div>

    </div>
</template>

<script>
import {
    adminGetSchoolAuthRecordList,
} from "@/api/admin";
export default {
    name: "school-subject-permissions",
    data() {
        return {
            formInline: {},
            page_no: 1,
            page_size: 10,
            total: 0,
            tableData: [],

        };
    },
    mounted() {
        if (!this.$route.query.id) {
            this.$message.warning("请选择校区");
            this.$router.push({
                name: "cooperative-school",
            });
            return;
        }

        this.adminGetSchoolAuthRecordList();
    },
    methods: {
        adminGetSchoolAuthRecordList() {
            adminGetSchoolAuthRecordList({
                page_no: this.page_no,
                page_size: this.page_size,
                schoolId: this.$route.query.id,
                data_type: this.formInline.data_type
            }).then((res) => {
                console.log(res, 1215241521);
                this.total = res.total
                this.tableData = res.schoolAuthRecordList
            })
        },
        search() {
            this.page_no = 1;
            this.adminGetSchoolAuthRecordList();

        },
        handleCurrentChange(val) {
            this.page_no = val;
            this.adminGetSchoolAuthRecordList();

        },

    },
};
</script>

<style scoped lang="scss">
.school-subject-permissions {
    height: 100%;
    background-color: #fff;
    padding-top: 3px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 20px;
    margin: 10px;
    border-radius: 5px;

    .table-style {}
}
</style>
